// @import dependencies
import React, {Component, CSSProperties} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {AvatarCommonLayout} from 'app_components/commons/avatar'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IAvatarCommonProps {
  name?: string
  src: string
  size?: string
  rounded?: boolean
  circle?: boolean
  active?:boolean
  style?: CSSProperties
  onClick?: ()=>void
}
interface IAvatarCommonState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class AvatarCommon extends Component<IAvatarCommonProps, IAvatarCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IAvatarCommonProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <AvatarCommonLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(AvatarCommon)
